export const ENQUEUE_SNACKBAR = 'notifications/ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'notifications/CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'notifications/REMOVE_SNACKBAR';
